import React from "react"
import { Flex, Box, Heading } from '@chakra-ui/react'
import Layout from '../layout'
import { useSelector } from "react-redux"
import { getConfig } from "../reducers"


const Aviso_privacidad = () => {


    const config = useSelector(state => getConfig(state))

    return (
        <Layout>


            <Box w={"full"} >
                <Flex maxW={"1400px"} flexDir={{ base: 'column', md: 'row' }} p={4} m={"auto"} mt={"7.5rem"}>
                    <Box flex={1} order={{ base: 2, md: 2 }} p={"10"} margin={"auto"} >
                        <Heading>Aviso de privacidad</Heading>
                        <br />
                        <div className="blogContent" dangerouslySetInnerHTML={{ __html: config.privacy }} />

                    </Box>

                </Flex>
            </Box>

        </Layout >
    )
}

export default Aviso_privacidad